// Empty module shim for unused transitive dependency (@m365-admin/table-list)
module.exports = {};
